import { render, staticRenderFns } from "./rule_add.vue?vue&type=template&id=cb73c9ec&"
import script from "./rule_add.vue?vue&type=script&lang=js&"
export * from "./rule_add.vue?vue&type=script&lang=js&"
import style0 from "./rule_add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports